document.addEventListener('DOMContentLoaded', function () {
  function bindNav(trackSelector, prevSelector, nextSelector, opts) {
    var track = document.querySelector(trackSelector);
    if (!track || track.getAttribute('data-mwu-nav-bound') === '1') return;
    track.setAttribute('data-mwu-nav-bound', '1');
    var prev = document.querySelector(prevSelector);
    var next = document.querySelector(nextSelector);
    var amount = function () {
      if (opts && opts.cardSelector) {
        var card = track.querySelector(opts.cardSelector);
        if (card) {
          var gapRaw = window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap;
          var gap = parseFloat(gapRaw) || 0;
          return card.getBoundingClientRect().width + gap;
        }
      }
      return Math.min(track.clientWidth * 0.9, 800);
    };
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
      });
    }
  }
  bindNav(
    '.mwu-001-sg-lp-mech__track--root',
    '.mwu-001-sg-lp-mech__prev',
    '.mwu-001-sg-lp-mech__next'
  );
  bindNav(
    '.mwu-001-sg-lp-tst__track--root',
    '.mwu-001-sg-lp-tst__prev',
    '.mwu-001-sg-lp-tst__next',
    { cardSelector: '.mwu-001-sg-lp-tst__card' }
  );

  /** SG LP stats count-up — Figma 27:1578 (Happy customers / Verified reviews) */
  function mwuStatsFormatThousands(n) {
    var rounded = Math.floor(Math.max(0, n));
    return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
  }

  function mwuEaseOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  function mwuStatsRunCounter(host) {
    var target = parseInt(host.getAttribute('data-mwu-stats-target'), 10);
    var from = parseInt(host.getAttribute('data-mwu-stats-from') || '0', 10);
    var dur = parseInt(host.getAttribute('data-mwu-stats-duration-ms') || '2200', 10);
    var out = host.querySelector('[data-mwu-stats-count-display]');
    if (!out || Number.isNaN(target)) return;

    var start = window.performance.now();
    function tick(now) {
      var elapsed = now - start;
      var u = dur <= 0 ? 1 : Math.min(1, elapsed / dur);
      var eased = mwuEaseOutQuart(u);
      var cur = from + (target - from) * eased;
      out.textContent = mwuStatsFormatThousands(cur);
      if (u < 1) {
        window.requestAnimationFrame(tick);
      } else {
        out.textContent = mwuStatsFormatThousands(target);
      }
    }
    window.requestAnimationFrame(tick);
  }

  function initMwuStatsCounters() {
    var nodes = document.querySelectorAll('[data-mwu-stats-count]');
    if (!nodes.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.target.getAttribute('data-mwu-stats-ran') === '1')
            return;
          entry.target.setAttribute('data-mwu-stats-ran', '1');
          mwuStatsRunCounter(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );

    for (var i = 0; i < nodes.length; i++) {
      io.observe(nodes[i]);
    }
  }

  initMwuStatsCounters();

  /** LP sticky nav — pins to viewport top once you scroll past the strip (#main-nav matches .tw-container width) */
  function mwuLpStickyNavPinTick() {
    var holder = document.querySelector('[data-mwu-lp-stickynav-root]');
    var bar = holder && holder.querySelector('[data-mwu-lp-stickynav]');
    if (!holder || !bar) return;

    if (!holder._mwuPinNav) holder._mwuPinNav = { pinned: false, pinThreshold: 0 };

    var s = holder._mwuPinNav;

    function readTopPx() {
      var cs = getComputedStyle(document.documentElement);
      var v = parseFloat(cs.getPropertyValue('--mwu-lp-sticky-nav-top'));
      return Number.isNaN(v) ? 0 : v;
    }

    if (!s.pinned) {
      s.pinThreshold =
        holder.getBoundingClientRect().top + window.pageYOffset - readTopPx();
    }

    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (!s.pinned && y >= s.pinThreshold) {
      s.pinned = true;
      bar.classList.add('is-pinned');
      holder.style.minHeight = Math.ceil(bar.offsetHeight) + 'px';
    } else if (s.pinned && y < s.pinThreshold - 1) {
      s.pinned = false;
      bar.classList.remove('is-pinned');
      holder.style.minHeight = '';
      s.pinThreshold =
        holder.getBoundingClientRect().top + window.pageYOffset - readTopPx();
    } else if (s.pinned) {
      holder.style.minHeight = Math.ceil(bar.offsetHeight) + 'px';
    }
  }

  function initMwuLpStickyNavPin() {
    mwuLpStickyNavPinTick();
    if (!window.__mwuLpStickyNavPinBound) {
      window.__mwuLpStickyNavPinBound = true;
      window.addEventListener('scroll', mwuLpStickyNavPinTick, { passive: true });
      window.addEventListener('resize', mwuLpStickyNavPinTick);
      document.addEventListener('shopify:section:load', function () {
        var roots = document.querySelectorAll('[data-mwu-lp-stickynav-root]');
        for (var r = 0; r < roots.length; r++) {
          delete roots[r]._mwuPinNav;
        }
        mwuLpStickyNavPinTick();
        window.requestAnimationFrame(mwuLpStickyNavPinTick);
      });
    }
    window.requestAnimationFrame(mwuLpStickyNavPinTick);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(mwuLpStickyNavPinTick);
  }

  initMwuLpStickyNavPin();
  /** LP sticky section nav — active state while scrolling (Figma 252:10138) */
  function initMwuLpStickyNavSpy() {
    var root = document.querySelector('[data-mwu-lp-stickynav]');
    if (!root || root.getAttribute('data-mwu-stickynav-spy-bound') === '1') return;
    var anchors = root.querySelectorAll('[data-anchor-target]');
    if (!anchors.length) return;
    var ids = [];
    for (var ai = 0; ai < anchors.length; ai++) {
      var id = anchors[ai].getAttribute('data-anchor-target');
      if (!id || ids.indexOf(id) >= 0) continue;
      ids.push(id);
    }
    var targets = ids
      .map(function (nid) {
        return document.getElementById(nid);
      })
      .filter(Boolean);
    if (!targets.length) return;
    root.setAttribute('data-mwu-stickynav-spy-bound', '1');

    function setActive(id) {
      for (var j = 0; j < anchors.length; j++) {
        var el = anchors[j];
        var isMatch = el.getAttribute('data-anchor-target') === id;
        if (isMatch) {
          el.classList.add('is-active');
          el.setAttribute('aria-current', 'location');
        } else {
          el.classList.remove('is-active');
          el.removeAttribute('aria-current');
        }
      }
    }

    function consider(entries) {
      var hit = [];
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) hit.push(entries[k].target);
      }
      if (!hit.length) return;
      hit.sort(function (a, b) {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
      });
      setActive(hit[0].id);
    }

    var io = new IntersectionObserver(
      function (entries) {
        consider(entries);
      },
      {
        root: null,
        rootMargin: '-32% 0px -52% 0px',
        threshold: 0,
      }
    );

    for (var t = 0; t < targets.length; t++) {
      io.observe(targets[t]);
    }

    var initial = ids[0];
    if (location.hash.length > 1) {
      var raw = decodeURIComponent(location.hash.slice(1));
      if (ids.indexOf(raw) >= 0) initial = raw;
    }
    setActive(initial);
  }

  initMwuLpStickyNavSpy();
  document.addEventListener('shopify:section:load', initMwuLpStickyNavSpy);
  /** SG LP product purchase — gallery thumbnails + variant heading label (Figma purchase section) */
  function mwuInitPurchaseGalleries() {
    document.querySelectorAll('[data-mwu-purchase-gallery]').forEach(function (root) {
      if (root.getAttribute('data-mwu-gallery-bound') === '1') return;
      root.setAttribute('data-mwu-gallery-bound', '1');
      var sec = root.closest('.mwu-001-sg-lp-purchase');
      var sid = sec && sec.getAttribute('data-section-id');
      var mainSlot = sid ? document.getElementById('product-images-' + sid) : null;
      if (!mainSlot) return;
      root.querySelectorAll('[data-mwu-purchase-gallery-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tpl = btn.querySelector('template[data-mwu-purchase-gallery-main-html]');
          if (!tpl) return;
          mainSlot.innerHTML = tpl.innerHTML;
          root.querySelectorAll('[data-mwu-purchase-gallery-thumb]').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
        });
      });
    });
  }

  function mwuInitPurchaseSizeLabels() {
    document.querySelectorAll('.mwu-001-sg-lp-purchase[data-mwu-purchase-size-label]').forEach(function (sec) {
      var label = sec.getAttribute('data-mwu-purchase-size-label');
      if (!label) return;
      var n = 0;
      var id = window.setInterval(function () {
        var h = sec.querySelector('.variant-selectors .variant-heading');
        if (h) {
          h.textContent = label;
          window.clearInterval(id);
        } else if (++n > 60) window.clearInterval(id);
      }, 50);
    });
  }

  function initMwuSgLpFaqAccordion() {
    document
      .querySelectorAll('.mwu-001-sg-lp-faq.mwu-001-sg-lp-anchor-target .mwu-001-sg-lp-faq__list')
      .forEach(function (list) {
        if (list.getAttribute('data-mwu-faq-accordion-bound') === '1') return;
        list.setAttribute('data-mwu-faq-accordion-bound', '1');
        list.querySelectorAll('.mwu-001-sg-lp-faq__item').forEach(function (detail) {
          detail.addEventListener('toggle', function () {
            if (!detail.open) return;
            list.querySelectorAll('.mwu-001-sg-lp-faq__item').forEach(function (other) {
              if (other !== detail) other.removeAttribute('open');
            });
          });
        });
      });
  }

  function initMwuSgLpPurchaseDetailsAccordion() {
    document.querySelectorAll('.mwu-001-sg-lp-purchase-details').forEach(function (region) {
      if (region.getAttribute('data-mwu-purchase-details-accordion-bound') === '1') return;
      region.setAttribute('data-mwu-purchase-details-accordion-bound', '1');
      region.querySelectorAll('.mwu-001-sg-lp-purchase-details__item').forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (!detail.open) return;
          region.querySelectorAll('.mwu-001-sg-lp-purchase-details__item').forEach(function (other) {
            if (other !== detail) other.removeAttribute('open');
          });
        });
      });
    });
  }

  function mwuSgLpNormalizeQtyPrices(shell) {
    shell.querySelectorAll('.variant__radios:not(.variant__radios--frequency) .variant__radio-price').forEach(function (el) {
      function stripTextNodes(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.data = node.data.replace(/\s+[A-Za-z]{3}\s+each\b/gi, ' each');
        } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length) {
          Array.prototype.slice.call(node.childNodes).forEach(stripTextNodes);
        }
      }
      stripTextNodes(el);
    });
  }

  /** Figma 252:3385 — “Save 15%” / “+ Free Shipping” on separate lines. */
  function mwuSgLpFormatQtyPromoBadges(shell) {
    shell.querySelectorAll('.variant__radios:not(.variant__radios--frequency) .variant__radio-badge').forEach(function (badge) {
      if (badge.querySelector('svg,img')) return;
      if (badge.querySelector('.mwu-001-sg-lp-purchase__qty-badge-line')) return;

      var raw = badge.textContent.replace(/\s+/g, ' ').trim();
      var parts = raw.split(/\s*\+\s*/);
      if (parts.length < 2) {
        var plus = raw.match(/^(.+?)\s*\+\s*(.+)$/);
        if (plus) {
          parts = [plus[1].trim(), plus[2].trim()];
        }
      }
      if (parts.length < 2) return;

      var line2 = parts.slice(1).join(' + ').trim();
      badge.textContent = '';
      var l1 = document.createElement('span');
      l1.className = 'mwu-001-sg-lp-purchase__qty-badge-line';
      l1.textContent = parts[0].trim();
      var l2 = document.createElement('span');
      l2.className = 'mwu-001-sg-lp-purchase__qty-badge-line';
      l2.textContent = '+ ' + line2;
      badge.appendChild(l1);
      badge.appendChild(l2);
    });
  }

  /** Qty tile: “$59.99” and “each” on separate lines (under title). */
  function mwuSgLpFormatQtyPriceStack(shell) {
    shell.querySelectorAll('.variant__radios:not(.variant__radios--frequency) .variant__radio-price').forEach(function (el) {
      if (el.querySelector('.mwu-001-sg-lp-purchase__qty-price-stack')) return;

      function splitEach(str) {
        var t = String(str).replace(/\s+/g, ' ').trim();
        var m = t.match(/^(.+?)\s+each$/i);
        if (!m) return null;
        return { amt: m[1].trim() };
      }

      function appendStack(container, parts) {
        container.textContent = '';
        var stack = document.createElement('span');
        stack.className = 'mwu-001-sg-lp-purchase__qty-price-stack';
        var num = document.createElement('span');
        num.className = 'mwu-001-sg-lp-purchase__qty-price-num';
        num.textContent = parts.amt;
        var eachEl = document.createElement('span');
        eachEl.className = 'mwu-001-sg-lp-purchase__qty-price-each';
        eachEl.textContent = 'each';
        stack.appendChild(num);
        stack.appendChild(eachEl);
        container.appendChild(stack);
      }

      function migrateLegacyInlineRow(container) {
        var legacy = container.querySelector('.mwu-001-sg-lp-purchase__qty-price-row');
        if (!legacy) return null;
        var n = legacy.querySelector('.mwu-001-sg-lp-purchase__qty-price-num');
        if (!n || !n.textContent.trim()) {
          legacy.remove();
          return null;
        }
        var amt = n.textContent.trim();
        legacy.remove();
        return { amt: amt };
      }

      var strike = el.querySelector('s');
      var afterStrike = strike && el.querySelector('s + span');
      if (afterStrike) {
        var migA = migrateLegacyInlineRow(afterStrike);
        if (migA) {
          appendStack(afterStrike, migA);
          return;
        }
        var p = splitEach(afterStrike.textContent);
        if (p) appendStack(afterStrike, p);
        return;
      }

      var migB = migrateLegacyInlineRow(el);
      if (migB) {
        appendStack(el, migB);
        return;
      }
      var p2 = splitEach(el.textContent);
      if (p2) appendStack(el, p2);
    });
  }

  function mwuSgLpMovePaylater(shell) {
    var sec = shell.closest('.mwu-001-sg-lp-purchase');
    var pay = sec && sec.querySelector('.mwu-001-sg-lp-purchase__paylater');
    var host = shell.querySelector('product-form');
    if (!pay || !host) return;
    var inner = host.querySelector('.product-form');
    var buttons = inner && inner.querySelector('.product-form__buttons');
    if (!inner || !buttons) return;
    if (pay.parentElement === inner && pay.nextElementSibling === buttons) return;
    inner.insertBefore(pay, buttons);
  }

  function mwuAltFreqPriceDisplay(s) {
    if (!s) return '';
    var t = String(s).trim();
    var m = t.match(/\$[\d,]+(?:\.\d{2})?/);
    return m ? m[0] : t;
  }

  function mwuStripDeliverEveryName(name) {
    return String(name || '').replace(/^(delivered\s+every|every)\s+/i, '');
  }

  function mwuPlanSaveSuffix(plan) {
    var adj = plan.price_adjustments && plan.price_adjustments[0];
    if (!adj) return '';
    var u = adj.value + (adj.value_type === 'percentage' ? '%' : '');
    return '(Save ' + u + ')';
  }

  function mwuPlanFullSelectLabel(plan) {
    var adj = plan.price_adjustments && plan.price_adjustments[0];
    var d = adj ? adj.value + (adj.value_type === 'percentage' ? '%' : '') : '';
    var base = mwuStripDeliverEveryName(plan.name);
    return d ? base + ' (Save ' + d + ')' : base;
  }

  function mwuGetFrequencySelectedPlanId(wrap) {
    var el = wrap.querySelector('.custom-select__selected [data-selected-id]');
    if (!el) return null;
    var v = el.getAttribute('data-selected-id');
    if (v == null || v === '') return null;
    var n = parseInt(v, 10);
    return String(Number.isNaN(n) ? v : n);
  }

  function mwuTryClickFrequencyPlanOption(wrap, fullLabel) {
    var opts = wrap.querySelectorAll('.custom-select__option');
    var i;
    var t;
    for (i = 0; i < opts.length; i++) {
      t = opts[i].textContent.replace(/\s+/g, ' ').trim();
      if (t === fullLabel) {
        opts[i].click();
        var root = wrap.querySelector('.custom-select');
        if (root && root.classList.contains('isOpen')) {
          var selBtn = wrap.querySelector('button.custom-select__selected');
          if (selBtn) selBtn.click();
        }
        return true;
      }
    }
    return false;
  }

  function mwuActivateFrequencyPlanOption(wrap, fullLabel) {
    if (mwuTryClickFrequencyPlanOption(wrap, fullLabel)) return;
    var root = wrap.querySelector('.custom-select');
    var btn = wrap.querySelector('button.custom-select__selected');
    if (!btn) return;
    if (root && !root.classList.contains('isOpen')) btn.click();
    window.setTimeout(function () {
      mwuTryClickFrequencyPlanOption(wrap, fullLabel);
    }, 100);
  }

  function mwuSgLpMountDeliveryEveryOutside(subCard, altRoot, host) {
    if (!subCard || !altRoot || !host) return;
    var row = subCard.querySelector('.alt-freq__frequency-row');
    if (!row) return;

    var delivery = null;
    var nextSib = subCard.nextElementSibling;
    if (nextSib && nextSib.classList.contains('mwu-001-sg-lp-alt-freq__delivery')) {
      delivery = nextSib;
    } else {
      delivery = altRoot.querySelector('.mwu-001-sg-lp-alt-freq__delivery');
      if (!delivery) {
        delivery = document.createElement('div');
        delivery.className = 'mwu-001-sg-lp-alt-freq__delivery';
        subCard.insertAdjacentElement('afterend', delivery);
      }
    }
    if (row.parentElement !== delivery) delivery.appendChild(row);

    row.classList.add('mwu-001-sg-lp-freq-row--tiles');

    var raw = host.getAttribute('selling-plans');
    var groups;
    try {
      groups = raw ? JSON.parse(raw) : [];
    } catch (e) {
      groups = [];
    }
    var group = groups[0];
    if (!group || !group.selling_plans || !group.selling_plans.length) return;

    var wrap = row.querySelector('.custom-select-wrap');
    if (!wrap) return;

    var tilesRoot = row.querySelector('.mwu-001-sg-lp-freq-tiles');
    if (!tilesRoot) {
      tilesRoot = document.createElement('div');
      tilesRoot.className = 'mwu-001-sg-lp-freq-tiles';
      tilesRoot.setAttribute('role', 'radiogroup');
      tilesRoot.setAttribute('aria-label', 'Delivery frequency');
      wrap.insertAdjacentElement('beforebegin', tilesRoot);
    }

    if (!tilesRoot._mwuFreqClickDelegated) {
      tilesRoot._mwuFreqClickDelegated = true;
      tilesRoot.addEventListener('click', function (e) {
        var btn = e.target.closest('.mwu-001-sg-lp-freq-tile');
        if (!btn || !tilesRoot.contains(btn)) return;
        var fl = btn.getAttribute('data-full-label');
        if (fl) mwuActivateFrequencyPlanOption(wrap, fl);
      });
    }

    function syncTilesActive() {
      var sid = mwuGetFrequencySelectedPlanId(wrap);
      tilesRoot.querySelectorAll('.mwu-001-sg-lp-freq-tile').forEach(function (btn) {
        var pid = btn.getAttribute('data-plan-id');
        var on = sid != null && String(pid) === String(sid);
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    var sig = group.selling_plans
      .map(function (p) {
        return p.id;
      })
      .join(',');
    if (tilesRoot.getAttribute('data-mwu-freq-sig') !== sig) {
      tilesRoot.setAttribute('data-mwu-freq-sig', sig);
      tilesRoot.querySelectorAll('.mwu-001-sg-lp-freq-tile').forEach(function (n) {
        n.remove();
      });
      group.selling_plans.forEach(function (plan) {
        var fullLabel = mwuPlanFullSelectLabel(plan);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mwu-001-sg-lp-freq-tile';
        b.setAttribute('data-plan-id', String(plan.id));
        b.setAttribute('data-full-label', fullLabel);
        b.setAttribute('aria-checked', 'false');
        var t1 = document.createElement('span');
        t1.className = 'mwu-001-sg-lp-freq-tile__title';
        t1.textContent = mwuStripDeliverEveryName(plan.name);
        var t2 = document.createElement('span');
        t2.className = 'mwu-001-sg-lp-freq-tile__save';
        t2.textContent = mwuPlanSaveSuffix(plan);
        b.appendChild(t1);
        b.appendChild(t2);
        tilesRoot.appendChild(b);
      });
    }

    syncTilesActive();

    if (!wrap._mwuFreqMo) {
      wrap._mwuFreqMo = true;
      var mo = new MutationObserver(function () {
        syncTilesActive();
      });
      mo.observe(wrap, { subtree: true, characterData: true, attributes: true, childList: true });
    }

    function updateDeliveryVisibility() {
      var subOn = subCard.classList.contains('is-selected');
      delivery.classList.toggle('is-visible', subOn);
      if (subOn) delivery.removeAttribute('hidden');
      else delivery.setAttribute('hidden', '');
    }
    updateDeliveryVisibility();
    if (!delivery._mwuVisMo) {
      delivery._mwuVisMo = true;
      var mo2 = new MutationObserver(updateDeliveryVisibility);
      mo2.observe(subCard, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function mwuSgLpEnhanceAlternateFrequency(shell) {
    var host = shell.querySelector('product-form');
    var inner = host && host.querySelector('.product-form');
    if (!inner || !host) return;
    var altRoot = inner.querySelector('.alt-freq');
    if (!altRoot) return;
    var sec = shell.closest('.mwu-001-sg-lp-purchase');
    var subcopyRaw = sec && sec.getAttribute('data-mwu-subscribe-subcopy');
    var subcopy = typeof subcopyRaw === 'string' ? subcopyRaw.trim() : '';
    var oneTimeLabelRaw = sec && sec.getAttribute('data-mwu-onetime-label');
    var oneTimeLabel =
      typeof oneTimeLabelRaw === 'string' && oneTimeLabelRaw.trim()
        ? oneTimeLabelRaw.trim()
        : 'One-Time Purchase';
    var savingsLineRaw = sec && sec.getAttribute('data-mwu-subscribe-savings-copy');
    var savingsLine = typeof savingsLineRaw === 'string' ? savingsLineRaw.trim() : '';
    var mpRaw = sec && sec.getAttribute('data-mwu-most-popular-badge');
    var mostPopularBadge = typeof mpRaw === 'string' ? mpRaw.trim() : '';

    var btn = inner.querySelector('.product-form__submit.btn');
    var oneTimePricePlain = '';
    var origEl = altRoot.querySelector('.alt-freq__price-original');
    if (origEl && origEl.textContent) {
      oneTimePricePlain = mwuAltFreqPriceDisplay(origEl.textContent.trim());
    }
    if (!oneTimePricePlain && btn && btn.textContent) {
      var pm = btn.textContent.match(/\|\s*([^|\n]+)$/);
      if (pm) oneTimePricePlain = mwuAltFreqPriceDisplay(pm[1].trim());
    }

    var cards = altRoot.querySelectorAll('.alt-freq__card');
    var oneCard = null;
    var subCard = null;
    var ci;
    for (ci = 0; ci < cards.length; ci++) {
      var c = cards[ci];
      if (c.querySelector('.alt-freq__price-original')) {
        subCard = c;
        c.setAttribute('data-mwu-alt-card', 'subscribe');
      } else if (c.querySelector('.alt-freq__radio-dot')) {
        oneCard = c;
        c.setAttribute('data-mwu-alt-card', 'one-time');
      }
    }

    if (oneCard) {
      var olabel = oneCard.querySelector('.alt-freq__label');
      if (olabel) olabel.textContent = oneTimeLabel;
    }

    if (oneCard && oneTimePricePlain) {
      var headerOT = oneCard.querySelector('.alt-freq__card-header');
      var priceSlot = oneCard.querySelector('.mwu-001-sg-lp-alt-freq-onetime-price');
      if (headerOT && !priceSlot) {
        priceSlot = document.createElement('div');
        priceSlot.className = 'alt-freq__price-group mwu-001-sg-lp-alt-freq-onetime-price';
        var ps = document.createElement('span');
        ps.className = 'alt-freq__price-discounted';
        ps.textContent = oneTimePricePlain;
        priceSlot.appendChild(ps);
        headerOT.appendChild(priceSlot);
      } else if (priceSlot) {
        var exo = priceSlot.querySelector('.alt-freq__price-discounted');
        if (exo) exo.textContent = oneTimePricePlain;
      }
    }

    if (!subCard) return;
    mwuSgLpMountDeliveryEveryOutside(subCard, altRoot, host);

    var subHeader = subCard.querySelector('.alt-freq__card-header');
    if (!subHeader) return;

    var flexRow =
      subHeader.querySelector(':scope > .flex.items-center.gap-10') ||
      subHeader.querySelector('.mwu-001-sg-lp-alt-freq__left > .flex.items-center.gap-10');
    if (flexRow && !subHeader.querySelector('.mwu-001-sg-lp-alt-freq__left')) {
      var leftCol = document.createElement('div');
      leftCol.className = 'mwu-001-sg-lp-alt-freq__left';
      subHeader.insertBefore(leftCol, flexRow);
      leftCol.appendChild(flexRow);
    }
    var leftWrap = subHeader.querySelector('.mwu-001-sg-lp-alt-freq__left');
    /*
     * Figma 43:5263 — subscribe row is flex row items-center: [radio] [column: title + ships line],
     * not radio inline only with title.
     */
    if (
      leftWrap &&
      !leftWrap.querySelector('.mwu-001-sg-lp-alt-freq__text-stack')
    ) {
      var innerRow = leftWrap.querySelector(':scope > .flex.items-center.gap-10');
      var rDot = innerRow && innerRow.querySelector('.alt-freq__radio-dot');
      var lbl = innerRow && innerRow.querySelector('.alt-freq__label');
      if (innerRow && rDot && lbl) {
        var textStack = document.createElement('div');
        textStack.className = 'mwu-001-sg-lp-alt-freq__text-stack';
        textStack.appendChild(lbl);
        leftWrap.insertBefore(rDot, innerRow);
        innerRow.remove();
        leftWrap.appendChild(textStack);
      }
    }
    var textStack = leftWrap && leftWrap.querySelector('.mwu-001-sg-lp-alt-freq__text-stack');
    var subcopyParent = textStack || leftWrap;
    var subEl = subCard.querySelector('.mwu-001-sg-lp-alt-freq__subline');
    if (subcopy && subcopyParent) {
      if (!subEl) {
        subEl = document.createElement('p');
        subEl.className = 'mwu-001-sg-lp-alt-freq__subline';
        subcopyParent.appendChild(subEl);
      } else if (subEl.parentElement !== subcopyParent) {
        subcopyParent.appendChild(subEl);
      }
      subEl.textContent = subcopy;
    } else if (subEl) {
      subEl.remove();
    }

    var oldBundle = subCard.querySelector('.mwu-001-sg-lp-alt-freq__bundle-badge');
    if (oldBundle) oldBundle.remove();

    var mpEl = subCard.querySelector('.mwu-001-sg-lp-alt-freq-most-popular');
    if (mostPopularBadge) {
      if (!mpEl) {
        mpEl = document.createElement('span');
        mpEl.className = 'mwu-001-sg-lp-alt-freq-most-popular';
        mpEl.setAttribute('aria-hidden', 'true');
        subCard.appendChild(mpEl);
      }
      mpEl.textContent = mostPopularBadge;
    } else if (mpEl) {
      mpEl.remove();
    }

    var disc = subHeader.querySelector('.alt-freq__price-group .alt-freq__price-discounted');
    if (disc && !disc.querySelector('.mwu-001-sg-lp-alt-freq__mo-suffix')) {
      var moSpan = document.createElement('span');
      moSpan.className = 'mwu-001-sg-lp-alt-freq__mo-suffix';
      moSpan.textContent = '/mo';
      disc.appendChild(moSpan);
    }

    var priceGroup = subHeader.querySelector('.alt-freq__price-group');
    if (priceGroup) {
      var sl = priceGroup.querySelector('.mwu-001-sg-lp-alt-freq-savings-line');
      if (savingsLine) {
        if (!sl) {
          sl = document.createElement('p');
          sl.className = 'mwu-001-sg-lp-alt-freq-savings-line';
          priceGroup.appendChild(sl);
        }
        sl.textContent = savingsLine;
      } else if (sl) {
        sl.remove();
      }
    }
  }

  var mwuPurchaseEnhanceQueued = null;
  function mwuSgLpPurchaseEnhanceTick() {
    document.querySelectorAll('.mwu-001-sg-lp-purchase__form-shell').forEach(function (shell) {
      mwuSgLpMovePaylater(shell);
      mwuSgLpEnhanceAlternateFrequency(shell);
      mwuSgLpNormalizeQtyPrices(shell);
      mwuSgLpFormatQtyPromoBadges(shell);
      mwuSgLpFormatQtyPriceStack(shell);
    });
  }

  function mwuSgLpPurchaseEnhanceSchedule() {
    if (mwuPurchaseEnhanceQueued) clearTimeout(mwuPurchaseEnhanceQueued);
    mwuPurchaseEnhanceQueued = setTimeout(function () {
      mwuSgLpPurchaseEnhanceTick();
      mwuPurchaseEnhanceQueued = null;
    }, 80);
  }

  function initMwuSgLpPurchaseObservers() {
    document.querySelectorAll('.mwu-001-sg-lp-purchase__form-shell product-form').forEach(function (host) {
      if (host.getAttribute('data-mwu-purchase-enhance-obs') === '1') return;
      host.setAttribute('data-mwu-purchase-enhance-obs', '1');
      var obs = new MutationObserver(mwuSgLpPurchaseEnhanceSchedule);
      obs.observe(host, { childList: true, subtree: true });
    });
  }

  function mwuPurchaseEnhancements() {
    mwuInitPurchaseGalleries();
    mwuInitPurchaseSizeLabels();
    initMwuSgLpFaqAccordion();
    initMwuSgLpPurchaseDetailsAccordion();
    mwuSgLpPurchaseEnhanceTick();
    initMwuSgLpPurchaseObservers();
  }

  mwuPurchaseEnhancements();
  document.addEventListener('shopify:section:load', mwuPurchaseEnhancements);
});

